<ion-badge class="tip-badge">
  {{ amount|asGbp }} tip
</ion-badge>
